// extracted by mini-css-extract-plugin
export default {"root":"Navbar_root__ViPFC","menu-item":"Navbar_menu-item__S04Ak","menuItem":"Navbar_menu-item__S04Ak"};